<template>
<div
  class="card"
  v-loading="loading"
>
  <div class="card-header">
    <div class="row">
      <div class="col-md-6">
        <h4 class="card-title"><i class="ti-light-bulb"></i> Lâmpadas Trocadas ({{ countLamps }})</h4>
      </div>
      <div class="col-md-6 text-right">
        <button
          class="btn btn-fill btn-success btn-wd"
          @click="handleTermsDownload()"
        >
          Download dos Termos
        </button>
      </div>
    </div>
  </div>
  <div class="card-content">
    <div class="row">
      <div class="col-md-12">
        <el-table
          class="table-striped"
          :data="lamps"
        >
          <el-table-column
            label="Evento"
            property="event"
            v-if="hasEvent"
          >
            <template slot-scope="props">{{ props.row.hasOwnProperty('event') && props.row.event.hasOwnProperty('reference') ? props.row.event.reference : '-' }}</template>
          </el-table-column>
          <el-table-column
            label="Potência"
            property="power"
          >
            <template slot-scope="props">{{ props.row.power }}W</template>
          </el-table-column>
          <el-table-column
            label="Tipo de Lâmpada Recebida"
            property="type"
          />
          <el-table-column
            label="Cômodo"
            property="room"
          />
          <el-table-column
            label="Hora em Uso por Dia"
            property="usageHoursPerDay"
          />
          <el-table-column
            label="Trocada por"
            property="power"
          >
            <template slot-scope="props">{{ users[props.row.userId] }}</template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import JSZip from 'jszip'
import downloadJs from 'downloadjs'
import Couchdb from 'src/services/Couchdb'
import { mapGetters } from 'vuex'

export default {
  name: 'LampsList',
  props: {
    customer: {
      required: true,
      type: Object
    },
    eventId: {
      default: false
    }
  },
  data () {
    return {
      isRunningActions: false
    }
  },
  methods: {
    handleTermsDownload () {
      this.zipperTerms()
        .then(() => {})
        .catch((err) => {
          console.log(err)
        })
    },
    zipperTerms () {
      this.isRunningActions = true
      let zip = new JSZip()
      return Couchdb.connection('default')
        .collection('lamps')
        .select(['_id'])
        .where('customer.id', this.customer._id)
        .all()
        .then(lamps => {
          let promises = []
          for (let lamp of lamps) {
            promises.push(
              Couchdb
                .connection('docs')
                .where('referenceId', lamp._id)
                .all()
            )
          }
          Promise.all(promises)
            .then(lampDocs => {
              let promises2 = []
              let fileNames = []
              let countLamps = 1
              for (let doc of lampDocs) {
                const file = Object.assign({}, doc[0])
                if (!file.hasOwnProperty('_attachments')) {
                  continue
                }
                for (let index in file._attachments) {
                  fileNames.push(index)
                  promises2.push(
                    Couchdb.connection('docs')
                      .getAttachment(file._id, index)
                  )
                }
              }

              Promise.all(promises2)
                .then(attachments => {
                  for (let indexAttach in attachments) {
                    const attachment = attachments[indexAttach]
                    zip.file(countLamps + '_' + fileNames[indexAttach], attachment, attachment.type)
                    countLamps++
                  }

                  let data = this.$moment().format('DD_MM_YYYY')
                  let zipName = this.customer.uc + '_' + data + '.zip'
                  zip.generateAsync({ type: 'blob' })
                    .then(blob => {
                      downloadJs(blob, zipName)
                    })
                    .catch(err => {
                      console.log('zip error', err)
                    })
                })
                .catch(err => {
                  console.log('#4 -> err', err)
                })
            })
            .catch(err => {
              console.log('#2 -> err', err)
            })
        })
        .catch(err => {
          console.log('#1 -> err', err)
        })
        .finally(() => {
          this.isRunningActions = false
        })
    }
  },
  computed: {
    ...mapGetters('lamps', {
      allLamps: 'lampsAll',
      loading: 'loading'
    }),

    lamps: function () {
      if (this.allLamps.length <= 0) {
        return []
      }
      let lampadas = []
      this.allLamps.forEach(item => {
        for (let i = 0; i < item.items.length; i++) {
          item.items[i].userId = item.userId
          if (item.hasOwnProperty('event')) {
            item.items[i].event = item.event
          }
          lampadas.push(item.items[i])
        }
      })
      return lampadas
    },

    users: {
      get () {
        return this.$store.state.users.all && this.$store.state.users.all.length > 0 ? this.$store.state.users.all
          .filter(
            item => {
              return item.role !== 'superadmin'
            })
          .reduce(
            (obj, item) => {
              obj[item._id] = item.name
              return obj
            },
            {}
          ) : {}
      }
    },

    countLamps: function () {
      return this.lamps.length
    },

    hasEvent () {
      return this.lamps.find(item => item.hasOwnProperty('event'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Lamps/ListLamps.vue